<div class="hero__container">
  <div class="hero__title-container">
    <div class="hero__title">
      <h1>{{ title() }}</h1>
      <img [src]="'/icons/hero/' + icon() + '.svg'" />
    </div>
  </div>
</div>
